import { render, staticRenderFns } from "./header-image-uploader.vue?vue&type=template&id=1e87ffa1&scoped=true"
import script from "./header-image-uploader.vue?vue&type=script&lang=js"
export * from "./header-image-uploader.vue?vue&type=script&lang=js"
import style0 from "./header-image-uploader.vue?vue&type=style&index=0&id=1e87ffa1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87ffa1",
  null
  
)

export default component.exports